// removed by extract-text-webpack-plugin
module.exports = {"column-container-wrapper":"_3fIxHepNzyOFynXHirYapZ","dropdown-title":"KqjYJ6atIechInbM1OP5z","open":"_3Nsicv98BVGt5uf9O6Q7ML","header-link":"_31ZFvG34fxwDFFpKdLuKpl","link-list":"_2h6XFrRRLRC8rhVnb3EXsE","level-two":"CkhUFZnzDAnv-vZ-cQtfN","dropdown":"_1BHJPT-_xRI6PIwJ9I6ibW","dropdown-header-link":"hnjFO3OHXeXyXk4J4GFDD","dropdown-additional-info":"_3mEdK87jCh1AC5E39HbjPX","submenu":"_1FD3eG0py1qc0fNdCzIuIQ","close":"CU8kS8awrs9rjfIIqnai9","closeIcon":"_16VCCXUrm8E5HWdYH04-U0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownMenu/DropdownMenu.module.scss
// module id = 754
// module chunks = 0